import { Injectable } from '@angular/core';
import { HttpGeneralService } from '../../shared/shared';
import { CONFIG } from '../../shared/config';
import { simpleOrderService } from '../simple-order-request/simple-order-interfaces';

let ordersUrl = CONFIG.baseUrls.orders;
let ordering = CONFIG.baseUrls.ordering;
let medicalSheetsUrl = CONFIG.baseUrls.medicalSheets;
@Injectable()
export class ServiceHistoryService {
    constructor(private httpGeneralService: HttpGeneralService) { }

    patServicesLoad(_regPat: any) {
        return this.httpGeneralService.add(_regPat, `${ordersUrl}/patServicesLoad`);
    }
    portalPatServicesLoad(_regPat: any) {
        return this.httpGeneralService.add(_regPat, `${ordersUrl}/portalPatServicesLoad`);
    }
    RegEmergancyTransferLoad(_regPat: any) {
        return this.httpGeneralService.add(_regPat, `${ordersUrl}/RegEmergancyTransferLoad`);
    }
    UpdateSerivceMedicalStep(_regPat: any[]) {
        return this.httpGeneralService.add(_regPat, `${ordering}/UpdateSerivceMedicalStep`);
    }
    ReloadDentialCycleDoctor(_regPat: any) {
      return this.httpGeneralService.add(_regPat, `${ordering}/ReloadDentialCycleDoctor`);
  }
    treatmentPlanCharge(secSecurityRoles: simpleOrderService) {
        return this.httpGeneralService.add(secSecurityRoles, `${medicalSheetsUrl}/TreatmentPlanCharge`)
    }
    treatmentPlanCancelCharge(secSecurityRoles: simpleOrderService) {
        return this.httpGeneralService.add(secSecurityRoles, `${medicalSheetsUrl}/TreatmentPlanCancelCharge`)
    }
    repeatRegPatMedicalStepService(regPat: any){
        return this.httpGeneralService.add(regPat, `${ordering}/repeatRegPatMedicalStepService`);
    }
    UpdateApprovalNumber(serviceList: any[]) {
        return this.httpGeneralService.post(serviceList, `${ordering}/UpdateApprovalNumber`);
      }

      patMedicinesLoad(_regPat: any) {
        return this.httpGeneralService.add(_regPat, `${ordersUrl}/patMedicinesLoad`);
    }
    UpdateApprovalNumberForMedicines(medicinesList: any[]) {
        return this.httpGeneralService.post(medicinesList, `${ordering}/UpdateApprovalNumberForMedicines`);
      }
      ServiceImplementerInformationLoad(_regPat: any) {
        return this.httpGeneralService.add(_regPat, `${ordersUrl}/ServiceImplementerInformationLoad`);
    }
    AddRegPatService(regPatService: any) {
        return this.httpGeneralService.add(regPatService, `${ordersUrl}/AddRegPatService`)

    }
} 
